<template>
  <div class="dashboard-main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-end">
                <a :href="basePath+'/ports/new'" class="theme-btn theme-btn-small">
                  <i class="la la-plus mr-1"></i>
                  Liman Yarat
                </a>

              </div>
            </div>
            <div class="form-content pb-2">

              <h3 class="title">Liman Listesi</h3>
              <p class="font-size-14" v-if="portList != null">{{ portList.length }} liman listeleniyor</p>

              <div class="table-form table-responsive">
                <table class="table" data-show-toggle="false" data-paging="true">
                  <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th>Kodu</th>
                    <th>Adı</th>
                    <th></th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="port in portList" data-expanded="true" :key="port.id">
                    <th scope="row"><a :href="basePath+'/ports/'+port.id">#{{port.id}}</a></th>
                    <th>{{ port.code }}</th>
                    <th>{{ port.name }}</th>
                    <td>
                      <big-image-component v-if="port.imageUrl != null" :url="port.imageUrl"/>
                    </td>
                    <td>
                      <div class="row">
                        <div class="table-content mr-2" v-on:click="deletePort(port)">
                          <div class="theme-btn theme-btn-small">
                            <i class="la la-trash"></i>
                          </div>
                        </div>
                        <div class="table-content">
                          <a :href="basePath+'/ports/'+port.id" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                            <i class="la la-edit"></i>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";
import BigImageComponent from "../common/BigImageComponent";
import helper from "../../store/helper/cruiseStoreHelper";

export default {
  name: "PortList",
  components: {BigImageComponent},
  computed:{
    portList:{
      get(){
        return this.$store.getters.getPortList
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods:{
    deletePort(port){
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deletePort", port)
        .then(response => {
          messagePopupManager.showSuccess();
        })
        .catch(error => {
          helper.checkDeleteResponseCodeAndShowPopup(error.code);
        })
      })
    }
  },
  beforeCreate() {
    this.$store.dispatch("loadPortList");
  }
}
</script>

<style scoped>

</style>